<template>
  <div class="email-popup" v-if="isOpen">
    <div class="email-popup-body">
      <h3>We’ll text you<br>in a second.</h3>
      <icon name="popup-icon" />
      <p>Enter your email to receive Nerdhire discounts and promos</p>
      <form @submit.prevent="onSubmit">
        <input type="text" placeholder="Email" v-model="email">
        <button>SUBMIT EMAIL</button>
        <p class="decline" @click="togglePopup">No thank you.</p>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon'
import EventBus from '@/utils/event-bus'
export default {
  components: {
    Icon
  },
  data: function () {
    return {
      isOpen: false,
      email: null
    }
  },
  methods: {
    togglePopup () {
      document.body.classList.toggle('popup-opened')
      this.isOpen = !this.isOpen
    },
    onSubmit () {
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        fetch('/.netlify/functions/subscribeEmail', {
          method: 'POST',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ email: this.email })
        })
        this.email = null
        this.togglePopup()
      }
    }
  },
  mounted () {
    EventBus.$on('OPEN_POPUP', payload => {
      this.togglePopup()
    })
  }
}
</script>

<style lang="scss">
  .email-popup {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .8);

    &-body {
      text-align: center;
      width: 324px;
      height: 465px;
      background-color: var(--primary-white);
      border-radius: 12px;
      box-sizing: border-box;
      padding: 30px 30px;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      position: absolute;

      h3 {
        margin: 0 0 20px 0;
        font-size: 28px;
      }

      p {
        font-size: 14px;
      }

      input[type=text] {
        display: block;
        width: 100%;
        padding: 12px 15px;
        font-size: 18px;
        box-sizing: border-box;
        border-radius: 8px;
        border: 1px solid #DBDBDB;
        outline: none;
      }

      button {
        outline: none;
        margin-top: 10px;
        display: block;
        width: 100%;
        padding: 15px;
        border: none;
        border-radius: 8px;
        background-color: var(--primary-green);
        color: var(--primary-white);
        cursor: pointer;
        font-size: 14px;
        transition: background-color .2s ease-out;

        &:hover {
          background-color: var(--primary-green-hover);
        }
      }

      .decline {
        margin: 10px 0 0 0;
        color: var(--primary-green);
        font-size: 16px;
        cursor: pointer;
      }
    }
  }
</style>
